var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-button",
        {
          staticClass: "header-button",
          attrs: { title: "Edit run details" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.showEditRunDetails(_vm.run)
            },
          },
        },
        [_c("span", [_vm._v("Edit")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }